<template>
  <div class="wc-row">
    <div class="wc-col wc-col__sm-12 wc-col__md-12">
      <RequestIVKList></RequestIVKList>
    </div>
  </div>
</template>

<script setup lang="ts">
import RequestIVKList from '@/components/policy/self-services/RequestIVKList.vue'
</script>
